/* eslint-disable no-restricted-globals */
import * as React from 'react';
import Button from '@src/components/mobile-button';
import Input from '@src/components/mobile-input';
import { Modal } from 'antd';
import captchaHandlerDecorate from '@src/utils/captcha-deco-util';
import services from '@src/services/zt';
import style from './index.less';
import { withoutProps } from '@src/utils/data-utils';

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export default class SmsCodeInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      countDown: null,
      aid: 11,
      vCode: '',
      idCardNum: ''
    };
    this.onSmsButtonClick = this.onSmsButtonClick.bind(this);
  }

  // 通用弹窗提示
  alertInfo = (title, str) => {
    Modal.info({
      title: `${title}`,
      content: (
        <div>
          <p>{str}</p>
        </div>
      ),
      onOk() {}
    });
  };

  async onSmsButtonClick() {
    const { validateAndGetPhone } = this.props;
    const { aid, vCode } = this.state;
    const idCard = this.props.idCard;
    const userPhone = this.props.phone;
    console.log(userPhone);
    services
      .checkIdCard(aid, idCard)
      .then(data => {
        this.sendCode({
          phone: userPhone
        });
      })
      .catch(error => {
        this.alertInfo('提示', error.message);
      });

    // let response = await services.checkIdCard(aid, idCard);
    // if (!response.code) {
    //   const response = await this.sendCode({
    //     phone: userPhone
    //   });
    // } else {
    // }
  }

  async countDown(countDown) {
    const nextCountDown = countDown - 1;
    if (nextCountDown < 1) {
      this.setState({ countDown: null });
      return;
    }
    this.setState({ countDown: nextCountDown });
    await delay(1000);
    await this.countDown(nextCountDown);
  }

  @captchaHandlerDecorate()
  async sendCode({ phone, ...authParams }) {
    const { aid } = this.state;
    try {
      return await services.sendCode(aid, phone, authParams).then(() => {
        this.countDown(60);
      });
    } catch (e) {
      e && e.message && this.alertInfo('提示', e.message);
      throw e;
    }
  }

  renderButton() {
    let { buttonText = '获取验证码' } = this.props;
    const { countDown } = this.state;
    buttonText = countDown === null ? buttonText : `${countDown}秒后重试`;
    return (
      <Button size="medium" disabled={countDown} onClick={this.onSmsButtonClick}>
        {buttonText}
      </Button>
    );
  }

  updatePhone = vCode => {
    console.log(vCode);
    // const { vCode: thisVcode } = this.state;
    this.setState({
      vCode
    });
    if (this.props.onChange) {
      this.props.onChange(vCode);
    }
  };

  blur() {
    // console.log((/(iPhone|iPod|iPad);?/i).test(window.navigator.userAgent))
    let isIos = /(iPhone|iPod|iPad);?/i.test(window.navigator.userAgent);
    let isWx = /MicroMessenger/i.test(window.navigator.userAgent);

    if (isIos && isWx) {
      setTimeout(() => {
        console.log('scroll', document.body.scrollTop);
        document.body.scrollTop = 0;
      }, 30);
    }
  }

  render() {
    // noinspection JSUnusedLocalSymbols
    const { validateAndGetPhone, ...restProps } = withoutProps(this.props, ['idCard']);
    // const { validateAndGetPhone, ...restProps } = withoutProps(this.props);
    const { vCode } = this.state;
    return (
      <div className={style.smsCodeInput}>
        <div className={style.inputWrapper}>
          <Input
            {...restProps}
            value={vCode}
            onChange={this.updatePhone}
            onBlur={() => this.blur()}
            labelNumber={4}
            // children="手机号:"
            // placeholder="请输入手机号"
            className="loginInput"
          />
        </div>
        <div className={style.smsButton}>{this.renderButton()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/sms-code-input/index.js